import http from '@/utils/httpService';
import { rootPath } from '@/utils/globalParam';

/* ------------------
        轮播图
------------------ */
export const queryCarousel = data => http.Axios.post(rootPath + '/api/banner/getEnterpriseBannerList', data);
/* ------------------
        医疗健康
------------------ */
export const queryHealthy = data =>
  http.Axios.post(rootPath + '/api/noauth/healthServicePlatform/generateToken', data, {
    noLoading: true,
    responseType: 'arraybuffer',
  });
/* ------------------
      专属顾问
------------------ */
// 获取企业展示的顾问
export const queryCounselor = data =>
  http.Axios.post(rootPath + '/api/consultant/getAgentInfo', data, {
    noLoading: true,
  });
// 取消点赞
export const cancelLike = data =>
  http.Axios.post(rootPath + '/api/consultant/cancelLike', data, {
    noLoading: true,
  });
// 顾问点赞
export const addLike = data =>
  http.Axios.post(rootPath + '/api/consultant/addLike', data, {
    noLoading: true,
  });
/* ------------------
      顾问心选
------------------ */
// 获取企业顾问心选信息
export const getChooseInfo = data =>
  http.Axios.post(rootPath + '/api/consultantrecommend/getEnterpriseConsultantRecommendList', data, {
    noLoading: true,
  });
// 获取企业顾问心选详情
export const getChooseDetails = data =>
  http.Axios.post(rootPath + '/api/consultantrecommend/getEnterpriseConsultantRecommendDetail', data, {
    noLoading: true,
  });

/* ------------------
      知识资讯
------------------ */
// 获取知识咨询信息
export const getNewsInfo = data =>
  http.Axios.post(rootPath + '/api/knowledge/getEnterpriseKnowledgeList', data, {
    noLoading: true,
  });
// 获取知识咨询详情
export const getNewsDetails = data =>
  http.Axios.post(rootPath + '/api/knowledge/getEnterpriseKnowledgeDetail', data, {
    noLoading: true,
  });
  // 获取知识咨询列表
  export const batchFindListKnowledge=data=>http.Axios.post(rootPath+'/api/knowledge/batchFindListKnowledge',data)
 